import { useMemo } from "react";
import { useSelector } from "react-redux";

const usePermission = (permission) => {
  const { authPermission } = useSelector((state) => state.loginSlice);

  return useMemo(
    () => authPermission.includes(permission),
    [permission, authPermission]
  );
};

export default usePermission;
